<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-fetch-data="methods.fetchData"
        :method-create-data="methods.createData"
        :method-update-data="methods.updateData"
        :method-update-scheme="methods.updateScheme"
        :additional-validation-rules="rules"
        :send-all-form="true"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";

import addCollectionsToScheme from "@/utils/addCollectionsToScheme";
import {
  getDocSectionId as fetchData,
  postDocSection as createData,
  putDocSection as updateData,
  getDocSection,
} from "@/api/docSections";
import { DocSections as defaultScheme } from "@/api/schemes/docSections";
import store from "@/store";

const getRegional = async () => {
  const data = await getDocSection();
  const find = data.find((el) => el.type_id === store.getters.types.regional);
  if (find) return find.id;
  return !!find;
};

const rules = {
  type_id: function () {
    return {
      validator: async (rule, value, callback) => {
        if (!this.form) {
          callback();
          return;
        }

        let id = null;
        await getRegional().then((resp) => (id = resp));

        if (!value) {
          callback();
        } else if (
          value === store.getters.types.regional &&
          id !== this.form.id &&
          id
        ) {
          // проверка на наличие региональных инструкций
          callback(
            new Error("Секция региональных инструкций может быть только одна")
          );
        } else {
          callback();
        }
      },
      trigger: "change",
    };
  },
};

const updateScheme = async (scheme) => {
  try {
    scheme = await addCollectionsToScheme(scheme);
  } catch (err) {
    console.log(err);
  }
  return scheme;
};

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      scheme: defaultScheme,
      methods: {
        fetchData,
        createData,
        updateData,
        updateScheme,
      },
      rules: rules,
    };
  },
};
</script>
